const initCustomProduct = () => {
  const section = document.querySelector('.custom-product-page');
  if (!section) return;

  const form = section.querySelector('form[action*="/cart/add"]');
  
  // --- Cart Drawer Handler ---
  const openCartDrawer = () => {
    if (window.Shopify && typeof window.Shopify.openCartDrawer === 'function') {
      window.Shopify.openCartDrawer();
      return;
    }

    const builtInTrigger = document.querySelector(
      'button[data-testid="cart-drawer-trigger"], #custom-cart-drawer-trigger, .cart-drawer-trigger'
    );

    if (builtInTrigger) {
      builtInTrigger.click();
      return;
    }

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    window.dispatchEvent(new CustomEvent('cart:open', { bubbles: true, composed: true }));
  };

  const getFormData = () => {
    if (!form) return null;
    const variantInput = form.querySelector('input[name="id"]');
    const quantityInput = form.querySelector('input[name="quantity"]');
    if (!variantInput || !quantityInput) return null;

    return {
      id: variantInput.value,
      quantity: Number(quantityInput.value) || 1,
    };
  };

  const handleAddToCart = async (event) => {
    event.preventDefault();
    const submitButton = event.currentTarget;
    const payload = getFormData();
    if (!payload) return;

    submitButton.disabled = true;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (!response.ok) {
        throw data;
      }

      openCartDrawer();

      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          composed: true,
          detail: {
            resource: data,
            data: {
              itemCount: data.item_count,
              source: 'custom-product-add-to-cart',
            },
          },
        })
      );
    } catch (error) {
      console.error('Custom product add to cart failed:', error);
    } finally {
      submitButton.disabled = false;
    }
  };

  section.querySelectorAll('button[name="add"], .sticky-add-to-cart, [data-action="add-to-cart"], .buy-now-btn-custom:not(.sticky-buy-now):not([data-action="buy-now"])').forEach((button) => {
    button.addEventListener('click', handleAddToCart);
  });

  // --- Sticky Buy Now Handler ---
  section.querySelectorAll('.sticky-buy-now, [data-action="buy-now"]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const buyNowBtn = section.querySelector('[data-gokwik-function="buyNow"], [data-function="buyNow"], .gokwik-buy-now, .gokwik-checkout, button[name="checkout"], input[name="checkout"]');
      if (buyNowBtn && buyNowBtn !== button) {
        buyNowBtn.click();
      } else {
        if (form) {
          const checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'return_to';
          checkoutInput.value = '/checkout';
          form.appendChild(checkoutInput);
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      }
    });
  });

  // --- Quantity +/- Selector ---
  const quantityWrapper = section.querySelector('.qty-wrapper');
  if (quantityWrapper) {
    quantityWrapper.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;

      const quantityInput = section.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      const currentValue = Number(quantityInput.value) || 1;
      if (target.classList.contains('minus')) {
        event.preventDefault();
        quantityInput.value = String(Math.max(1, currentValue - 1));
      }

      if (target.classList.contains('plus')) {
        event.preventDefault();
        quantityInput.value = String(currentValue + 1);
      }
    });
  }

  // --- Mobile Touch Slider ---
  const sliderMobile = section.querySelector('.slider-mobile');
  const track = sliderMobile ? sliderMobile.querySelector('.slider-mobile-track') : null;
  const dotsContainer = section.querySelector('.slider-mobile-dots');

  let goToSlideFn = null;

  if (sliderMobile && track) {
    const slides = Array.from(track.querySelectorAll('.product-gallery-item'));
    const totalSlides = slides.length;
    let currentIndex = 0;

    let startX = 0;
    let startY = 0;
    let currentX = 0;
    let currentY = 0;
    let deltaX = 0;
    let deltaY = 0;
    let isDragging = false;
    let isScrolling = undefined; // undefined, true (vertical), false (horizontal)

    // Build dots dynamically
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      if (totalSlides > 1) {
        slides.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = `slider-mobile-dot${index === 0 ? ' active' : ''}`;
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            goToSlide(index);
          });
          dotsContainer.appendChild(dot);
        });
      }
    }

    const prevBtn = section.querySelector('.slider-mobile-arrow.prev');
    const nextBtn = section.querySelector('.slider-mobile-arrow.next');

    if (totalSlides <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    const updateArrows = () => {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === totalSlides - 1;
    };

    const updateDots = () => {
      if (!dotsContainer) return;
      const dots = dotsContainer.querySelectorAll('.slider-mobile-dot');
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    };

    const updateSlider = (smooth = true) => {
      if (currentIndex < 0) currentIndex = 0;
      if (currentIndex >= totalSlides) currentIndex = totalSlides - 1;

      const slideWidth = sliderMobile.clientWidth || track.offsetWidth;
      const targetTranslateX = -currentIndex * slideWidth;

      if (smooth) {
        track.style.transition = 'transform 0.3s cubic-bezier(0.25, 1, 0.5, 1)';
      } else {
        track.style.transition = 'none';
      }

      track.style.transform = `translate3d(${targetTranslateX}px, 0px, 0px)`;
      updateDots();
      updateArrows();
    };

    const goToSlide = (index) => {
      if (index < 0 || index >= totalSlides) return;
      currentIndex = index;
      updateSlider(true);
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(currentIndex + 1);
      });
    }

    goToSlideFn = goToSlide;
    updateArrows(); // Initial state

    const onTouchStart = (e) => {
      if (totalSlides <= 1) return;
      if (e.touches.length > 1) return;

      isDragging = true;
      isScrolling = undefined;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      currentX = startX;
      currentY = startY;
      deltaX = 0;
      deltaY = 0;

      track.style.transition = 'none';
    };

    const onTouchMove = (e) => {
      if (!isDragging) return;

      currentX = e.touches[0].clientX;
      currentY = e.touches[0].clientY;
      deltaX = currentX - startX;
      deltaY = currentY - startY;

      if (isScrolling === undefined) {
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX > absY && absX > 5) {
          isScrolling = false;
        } else if (absY >= absX && absY > 5) {
          isScrolling = true;
        }
      }

      if (isScrolling === true) {
        return; // Allow vertical page scroll
      }

      if (isScrolling === false) {
        if (e.cancelable) {
          e.preventDefault();
        }

        let moveX = deltaX;
        if ((currentIndex === 0 && deltaX > 0) || (currentIndex === totalSlides - 1 && deltaX < 0)) {
          moveX = deltaX * 0.3;
        }

        const slideWidth = sliderMobile.clientWidth || track.offsetWidth;
        const currentTranslate = -currentIndex * slideWidth;
        track.style.transform = `translate3d(${currentTranslate + moveX}px, 0px, 0px)`;
      }
    };

    const onTouchEnd = () => {
      if (!isDragging) return;
      isDragging = false;

      if (isScrolling === false) {
        const threshold = 50;
        if (deltaX < -threshold && currentIndex < totalSlides - 1) {
          currentIndex++;
        } else if (deltaX > threshold && currentIndex > 0) {
          currentIndex--;
        }
        updateSlider(true);
      } else {
        updateSlider(true);
      }

      isScrolling = undefined;
      deltaX = 0;
      deltaY = 0;
    };

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: false });
    track.addEventListener('touchend', onTouchEnd, { passive: true });
    track.addEventListener('touchcancel', onTouchEnd, { passive: true });

    // Initial setup: ALWAYS start at index 0
    currentIndex = 0;
    updateSlider(false);

    window.addEventListener('resize', () => {
      updateSlider(false);
    });

    window.addEventListener('pageshow', () => {
      currentIndex = 0;
      updateSlider(false);
    });
  }

  // --- Variant Selection Logic ---
  const variantContainer = section.querySelector('.product-variants');
  const productJsonEl = section.querySelector('script[id^="ProductJson-"]');

  if (variantContainer && productJsonEl) {
    try {
      const productData = JSON.parse(productJsonEl.textContent);

      const updateVariant = () => {
        const selectedOptions = Array.from(
          variantContainer.querySelectorAll('input[type="radio"]:checked')
        ).map((radio) => radio.value);

        const matchedVariant = productData.variants.find((variant) => {
          return variant.options.every((optionVal, index) => optionVal === selectedOptions[index]);
        });

        const hiddenInput = section.querySelector('input[name="id"]');
        const currentPriceEl = section.querySelector('.current-price');
        const addToCartBtns = section.querySelectorAll('button[name="add"], .sticky-add-to-cart, .buy-now-btn-custom');

        if (matchedVariant && matchedVariant.available) {
          if (hiddenInput) {
            hiddenInput.value = matchedVariant.id;
          }

          // Update price display
          if (currentPriceEl && matchedVariant.price) {
            currentPriceEl.innerHTML = (matchedVariant.price / 100).toLocaleString('en-US', {
              style: 'currency',
              currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
            });
          }

          addToCartBtns.forEach((btn) => {
            btn.disabled = false;
            if (btn.classList.contains('sticky-buy-now') || btn.getAttribute('data-action') === 'buy-now') {
              btn.textContent = 'Buy Now';
            } else if (btn.classList.contains('sticky-add-to-cart') || btn.getAttribute('data-action') === 'add-to-cart') {
              btn.textContent = 'Add to Cart';
            } else {
              btn.textContent = 'ADD TO CART';
            }
          });

          // If variant has featured image, jump mobile slider to matching image
          if (matchedVariant.featured_image && matchedVariant.featured_image.id && goToSlideFn) {
            const imageId = matchedVariant.featured_image.id;
            const matchingSlideIndex = Array.from(
              section.querySelectorAll('.slider-mobile-track .product-gallery-item')
            ).findIndex(
              (item) => item.getAttribute('data-image-id') == imageId || item.getAttribute('data-media-id') == imageId
            );

            if (matchingSlideIndex !== -1) {
              goToSlideFn(matchingSlideIndex);
            }
          }
        } else {
          // Clear hidden variant ID when unavailable/sold out combination is selected
          if (hiddenInput) {
            hiddenInput.value = '';
          }

          const buttonText = matchedVariant ? 'SOLD OUT' : 'UNAVAILABLE';
          addToCartBtns.forEach((btn) => {
            btn.disabled = true;
            btn.textContent = buttonText;
          });
        }
      };

      variantContainer.addEventListener('change', updateVariant);
    } catch (e) {
      console.error('Error parsing product JSON for variant handling:', e);
    }
  }

  // --- Mobile Sticky Bar Scroll Visibility ---
  const stickyBar = document.getElementById('MobileStickyBar');
  if (stickyBar) {
    const handleScroll = () => {
      if (window.innerWidth <= 768) {
        if (window.scrollY > 300) {
          stickyBar.classList.add('show');
        } else {
          stickyBar.classList.remove('show');
        }
      } else {
        stickyBar.classList.remove('show');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomProduct);
} else {
  initCustomProduct();
}
